export default __webpack_public_path__ + "resources/icons/n221-c209.webp";